/**
 * Validate the shape of a `?patient_id=` deep-link value.
 *
 * There is no in-app patient registry to check existence against (real
 * patients live only in the external Athena warehouse — see
 * `backend/app/authz/dependency.py`'s `OpenAccessPolicy` no-op), so this is a
 * format check against the two id shapes the app already produces itself:
 * the seeded synthetic ids (`P-123`) and legacy/warehouse numeric Athena ids
 * (matching `PatientSearch.tsx`'s own bare-numeric-id shortcut). Anything
 * else — empty, whitespace, or free text — is treated as malformed so the
 * app can fail visibly instead of silently opening an indistinguishable
 * "brand new empty patient" workspace (ADR-073).
 */
const PATIENT_ID_PATTERN = /^(P-\d+|\d+)$/i;

/**
 * Check whether a `patient_id` value matches a known id shape.
 *
 * @param patientId - The raw (untrimmed) query-param value.
 * @returns `true` if the trimmed value matches a known patient-id shape.
 */
export function isValidPatientId(patientId: string): boolean {
  return PATIENT_ID_PATTERN.test(patientId.trim());
}

export default isValidPatientId;
